import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Stegindikator from "./../";
export const _frontmatter = {
  "ingress": "Stegindikatoren skal vise stegvis progresjon gjennom en prosess."
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "table-of-contents"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#normal"
          }}>{`Normal`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#med-label"
          }}>{`Med label`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#kompakt"
          }}>{`Kompakt`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#kompakt-med-label"
          }}>{`Kompakt med label`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#autoresponsiv"
          }}>{`Autoresponsiv`}</a></li></ol></nav>
    <h2 {...{
      "id": "normal"
    }}>{`Normal`}</h2>
    <Example mdxType="Example">
  <Stegindikator steg={[{
        label: "Dette steget først"
      }, {
        label: "Og så dette steget",
        aktiv: true
      }, {
        label: "Deretter må du gjøre dette"
      }, {
        label: "Konklusjonen",
        disabled: true
      }]} onChange={() => {}} mdxType="Stegindikator" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Stegindikator
  steg={[
    { label: "Dette steget først" },
    { label: "Og så dette steget", aktiv: true },
    { label: "Deretter må du gjøre dette" },
    { label: "Konklusjonen", disabled: true },
  ]}
  onChange={() => {}}
/>
`}</code></pre>
    <h2 {...{
      "id": "med-label"
    }}>{`Med label`}</h2>
    <Example mdxType="Example">
  <Stegindikator steg={[{
        label: "Dette steget først"
      }, {
        label: "Og så dette steget",
        aktiv: true
      }, {
        label: "Deretter må du gjøre dette"
      }, {
        label: "Konklusjonen",
        disabled: true
      }]} onChange={() => {}} visLabel mdxType="Stegindikator" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Stegindikator
  steg={[
    { label: "Dette steget først" },
    { label: "Og så dette steget", aktiv: true },
    { label: "Deretter må du gjøre dette" },
    { label: "Konklusjonen", disabled: true },
  ]}
  onChange={() => {}}
  visLabel
/>
`}</code></pre>
    <h2 {...{
      "id": "kompakt"
    }}>{`Kompakt`}</h2>
    <Example mdxType="Example">
  <Stegindikator steg={[{
        label: "Dette steget først"
      }, {
        label: "Og så dette steget",
        aktiv: true
      }, {
        label: "Deretter må du gjøre dette"
      }, {
        label: "Konklusjonen",
        disabled: true
      }]} onChange={() => {}} kompakt mdxType="Stegindikator" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Stegindikator
  steg={[
    { label: "Dette steget først" },
    { label: "Og så dette steget", aktiv: true },
    { label: "Deretter må du gjøre dette" },
    { label: "Konklusjonen", disabled: true },
  ]}
  onChange={() => {}}
  kompakt
/>
`}</code></pre>
    <h2 {...{
      "id": "kompakt-med-label"
    }}>{`Kompakt med label`}</h2>
    <Example mdxType="Example">
  <Stegindikator steg={[{
        label: "Dette steget først"
      }, {
        label: "Og så dette steget",
        aktiv: true
      }, {
        label: "Deretter må du gjøre dette"
      }, {
        label: "Konklusjonen",
        disabled: true
      }]} onChange={() => {}} kompakt visLabel mdxType="Stegindikator" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Stegindikator
  steg={[
    { label: "Dette steget først" },
    { label: "Og så dette steget", aktiv: true },
    { label: "Deretter må du gjøre dette" },
    { label: "Konklusjonen", disabled: true },
  ]}
  onChange={() => {}}
  kompakt
  visLabel
/>
`}</code></pre>
    <h2 {...{
      "id": "autoresponsiv"
    }}>{`Autoresponsiv`}</h2>
    <p>{`Denne versjonen vil kontinuerlig overvåke tilgjenglig konteiner-plass og automatisk
bytte visningsmodus for å tilpasse seg bredden.`}</p>
    <Example noScroll mdxType="Example">
  <Stegindikator steg={[{
        label: "Dette steget først"
      }, {
        label: "Og så dette steget",
        aktiv: true
      }, {
        label: "Deretter må du gjøre dette"
      }]} onChange={() => {}} visLabel autoResponsiv mdxType="Stegindikator" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Stegindikator
  steg={[
    { label: "Dette steget først" },
    { label: "Og så dette steget", aktiv: true },
    { label: "Deretter må du gjøre dette" },
  ]}
  onChange={() => {}}
  visLabel
  autoResponsiv
/>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      